import DgKnowledgeBaseSelect from './src/main.vue'

// 为组件提供 install 安装方法，供按需引入
DgKnowledgeBaseSelect.install = function (Vue) {
  Vue.component(DgKnowledgeBaseSelect.name, DgKnowledgeBaseSelect)
}
export default DgKnowledgeBaseSelect

export { DgKnowledgeBaseSelect }